export default "__VITE_ASSET__BzVuPV6x__"